// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const applyDocumentLanguage = (lng) => {
  const base = String(lng || "ar").split("-")[0].toLowerCase();
  const dir = base === "ar" ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", base);
};

i18n
  .use(HttpBackend) // Load translations from public folder
  .use(LanguageDetector) // Detect saved / browser language
  .use(initReactI18next)
  .init({
    // Do NOT set `lng` here — it overrides detection and blocks language switching persistence.
    fallbackLng: "ar",
    supportedLngs: ["ar", "en"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    debug: false,
    backend: {
      loadPath: "/translations/{{lng}}/global.json",
    },
    detection: {
      // Prefer saved choice; default Arabic for first visit via fallbackLng
      order: ["localStorage", "sessionStorage", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      lookupSessionStorage: "i18nextLng",
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

i18n.on("initialized", () => {
  applyDocumentLanguage(i18n.resolvedLanguage || i18n.language);
});

i18n.on("languageChanged", (lng) => {
  applyDocumentLanguage(lng);
});

export default i18n;
